import { render } from "./index.vue?vue&type=template&id=53c3a95a&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=53c3a95a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c3a95a"]])

export default __exports__